<template>
  <section class="pb-8" id="contact">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row justify="center">
            <v-col cols="12" sm="5" style="margin-top: 1em;">
              <h1 class="font-weight-light display-1">Contact Us</h1>
              <h3 class="font-weight-light mt-3">
                Let's discuss how we can empower your business with IT solutions. Contact us today to schedule a consultation.
              </h3>
              <h3 class="font-weight-light" style="margin-top: 1em;">
                <p style="font-weight: bold;">Customer Service/Technology：</p>
                bennett@ternaryinnovation.com <br />
                lewis@ternaryinnovation.com
              </h3>
            </v-col>
            <v-col cols="12" sm="7">
              <!-- <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-text-field
                    v-model="name"
                    :rules="nameRules"
                    label="Name"
                    required
                ></v-text-field>

                <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="Email"
                    required
                ></v-text-field>

                <v-textarea
                    v-model="textArea"
                    :rules="textAreaRules"
                    label="Message"
                    required
                />

                <v-btn
                    :disabled="!valid"
                    color="primary"
                    :dark="valid"
                    rounded
                    block
                    class="mt-3"
                    @click="submit"
                >
                  Submit
                </v-btn>
              </v-form> -->
              <v-img
                src="@/assets/img/ill1.svg"
                class="d-block ml-auto mr-auto"
                max-width="400px"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <div class="svg-border-waves text-white" style="margin-top: 1em;">
      <v-img src="~@/assets/img/borderWavesBlue.svg"/>
    </div>
  </section>
</template>

<style scoped>
#contact {
  background-color: #f4f7f5;
}

.svg-border-waves .v-image {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: 100%;
  overflow: hidden;
}

</style>

<script>
  export default {
    data: () => ({
      icons: ["fa-facebook", "fa-twitter", "fa-linkedin", "fa-instagram"],
      valid: true,
      name: "",
      nameRules: [
        (v) => !!v || "Name is required"
      ],
      email: "",
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+\..+/.test(v) || "Email is not valid",
      ],
      textArea: "",
      textAreaRules: [
        (v) => !!v || "Message is required"
      ],
      lazy: false,
      snackbar: {
        enabled: false,
        text: '',
        color: ''
      }
    }),
    methods: {
      submit() {
      }
    }
  }
</script>
